import { apiService } from './api';

export const preofferService = {
  // Pour les entreprises (pré-offres actives seulement)
  async getActivePreoffers(filters = {}) {
    const params = new URLSearchParams();
    
    if (filters.category) params.append('category', filters.category);
    if (filters.type) params.append('type', filters.type);
    
    const url = `/preoffers/active${params.toString() ? `?${params.toString()}` : ''}`;
    const response = await apiService.get(url);
    return response.data;
  },

  // Exprimer son intérêt pour une pré-offre
  async expressInterest(preofferId, interestData) {
    const response = await apiService.post(`/preoffers/${preofferId}/interest`, interestData);
    return response.data;
  }
};